import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import ReactTooltip from 'react-tooltip'
import config from '../../config'
import {
  Link,
  LinkIcon,
  CompanyIsFlag
} from '../'
import Styles from './CompanyIsWff.css'


@CSSModules(Styles, {allowMultiple:true})
export default class CompanyIsWff extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
  }
  constructor(props){
    super(props)
    const sources = (config.wffCompanySources && config.wffCompanySources[props.company.company_id]) ? config.wffCompanySources[props.company.company_id].slice(1) : null
    this.state = {
      company_sources: sources
    }
  }

  render() {
    if (!this.state.company_sources) return null
    const iconNw = require( '../../../static/images/icn-nw-no-circle-black.svg' )
    const iconCm = require( '../../../static/images/icn-cm-no-circle-black.svg' )
    const iconMmc2 = require( '../../../static/images/icn-mmc-black.svg' )
    const iconNw2 = require( '../../../static/images/icn-nw.svg' )
    const iconCm2 = require( '../../../static/images/icn-cm.svg' )

    return <div styleName='family-modal'>
      <div styleName='icon-row'>
        {
          this.props.company.is_mmc ?
            <CompanyIsFlag icon={iconMmc2} title='Military contractor'/> :
            null
        }
        {
          this.props.company.is_nw ?
            <CompanyIsFlag icon={iconNw2} title='Nuclear weapons' color='red'/> :
            null
        }
        {
          this.props.company.is_cm ?
            <CompanyIsFlag icon={iconCm2} title='Controversial weapons' color='red'/> :
            null
        }
      </div>
      <p>
        <span style={{fontWeight: '800'}}>Source data:</span> Below is a list of pension funds and asset managers that list
        this company for exclusion on the basis of involvement with military weapons. Exclusions for nuclear weapons or controversial weapons are marked with an icon.
      </p>
      <div styleName='sources-ul'>
        { this.state.company_sources.map((e, i) => {
          const source_idx = e[0]
          const special_str = e.length > 1 ? e[1].split('') : null
          const source_dat =  config.wffSources[source_idx]
          const source_shortname = source_dat[0]
          const source_desc = source_dat[1]
          const source_name = source_dat[2]
          let source_filename = source_dat[3]
          if (source_filename.slice(-3) === 'pdf' ||
              source_filename.slice(-4) === 'xlsx') {
            source_filename = config.links.exclusionListsS3 + source_filename
          }
          return <div
            key={'company-source-'+this.props.company.company_id+'-'+i}
            styleName='source-li'
          >
            <div styleName='source-shortname'>
              <div>
                <div>
                  <span
                    style={{display:'inline-block', width:'30px;'}}
                    data-multiline
                    data-effect='solid'
                    data-tip={"<div style='max-width:150px;'>"+source_desc+'</div>'}
                    data-for={'source-tooltip-'+i}
                    data-place='right'
                    data-html
                  >
                    <LinkIcon faclass='fa-info-circle'/>
                  </span>
                  &nbsp;&nbsp;&nbsp;
                  <b>{source_shortname}</b>
                </div>
                <div>
                  <Link
                    to={source_filename}
                    title={source_name}
                  >
                    {source_name}
                  </Link>
                </div>
              </div>
              <div>
                {
                  special_str && special_str.includes('n') ?
                    <img
                      styleName='detail-icon-holding'
                      src={iconNw}
                      alt='Nuclear weapons'
                      data-multiline
                      data-effect='solid'
                      data-tip="<div style='max-width:150px;'>Flagged for nuclear weapons</div>"
                      data-for={'source-icon1-'+i}
                      data-place='left'
                      data-html

                    /> : null
                }
                {
                  special_str && special_str.includes('c') ?
                    <img
                      styleName='detail-icon-holding'
                      src={iconCm}
                      alt='Controversial weapons'
                      data-multiline
                      data-effect='solid'
                      data-tip="<div style='max-width:150px;'>Flagged for controversial weapons</div>"
                      data-for={'source-icon2-'+i}
                      data-place='left'
                      data-html
                    /> : null
                }
              </div>
            </div>
            <ReactTooltip id={'source-tooltip-'+i}/>
            <ReactTooltip id={'source-icon1-'+i}/>
            <ReactTooltip id={'source-icon2-'+i}/>
          </div>
        }) }
      </div>
    </div>
  }
}

